"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformObjectToRemoveFields = void 0;
const tslib_1 = require("tslib");
const forOwn_1 = tslib_1.__importDefault(require("lodash/forOwn"));
const isArray_1 = tslib_1.__importDefault(require("lodash/isArray"));
const isObject_1 = tslib_1.__importDefault(require("lodash/isObject"));
const transformObjectToRemoveFields = (data) => {
    if ((0, isArray_1.default)(data)) {
        return data.map((item) => (0, exports.transformObjectToRemoveFields)(item));
    }
    if ((0, isObject_1.default)(data)) {
        let tmp = 'fields' in data ? Object.assign(Object.assign({}, data.fields), { sys: data.sys }) : data;
        tmp = (0, forOwn_1.default)(tmp, (v, k) => {
            tmp[k] = (0, exports.transformObjectToRemoveFields)(v);
        });
        return tmp;
    }
    return data;
};
exports.transformObjectToRemoveFields = transformObjectToRemoveFields;
//# sourceMappingURL=transformObjectToRemoveFields.js.map